// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"1144f99b","193":"83ea5a89"}[chunkId] + ".chunk.js";
};